import React, { useEffect, useState } from "react";

import SeedContext from "./SeedContext";
import { useAuthenticatedApi, useZoUnauthenticatedApi } from "../../hooks/useApi";

interface SeedProviderProps {
  name: "website" | "admin" | "webcheckin" | "supply" | "chat" | "booking";
}

const SeedProvider: React.FC<SeedProviderProps> = ({ children, name }) => {
  const fetchCRSSeed = useAuthenticatedApi("CRS_SEED");
  const fetchGeetaSeed = useAuthenticatedApi("ADMIN_SEED");
  const fetchProfileSeed = useAuthenticatedApi("PROFILE_SEED");
  const fetchSupplySeed = useAuthenticatedApi("SUPPLY_SEED");
  const fetchChatSeed = useAuthenticatedApi("ZOBU_CHAT_SEED");
  const fetchDiscoverSeed = useAuthenticatedApi("DISCOVER_SEED");
  const fetchBookingSeed = useZoUnauthenticatedApi("BOOKING_SEED");

  const [crsSeed, setCrsSeed] = useState(null);
  const [geetaSeed, setGeetaSeed] = useState(null);
  const [profileSeed, setProfileSeed] = useState(null);
  const [supplySeed, setSupplySeed] = useState(null);
  const [chatSeed, setChatSeed] = useState(null);
  const [discoverSeed, setDiscoverSeed] = useState(null);
  const [bookingSeed, setBookingSeed] = useState(null);

  useEffect(() => {
    if (name === "admin" && fetchCRSSeed) {
      fetchCRSSeed
        .get("")
        .then((e) => {
          setCrsSeed(e.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [fetchCRSSeed, name]);

  useEffect(() => {
    if (name === "admin" && fetchGeetaSeed) {
      fetchGeetaSeed
        .get("")
        .then((e) => {
          setGeetaSeed(e.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [fetchGeetaSeed, name]);

  useEffect(() => {
    if (name === "admin" && fetchDiscoverSeed) {
      fetchDiscoverSeed
        .get("")
        .then((e) => {
          setDiscoverSeed(e.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [fetchDiscoverSeed, name]);

  useEffect(() => {
    if (name === "webcheckin" && fetchProfileSeed) {
      fetchProfileSeed
        .get("")
        .then((e) => {
          setProfileSeed(e.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [fetchProfileSeed, name]);

  useEffect(() => {
    if ((name === "supply" || name === "website") && fetchSupplySeed) {
      fetchSupplySeed
        .get("")
        .then((e) => {
          setSupplySeed(e.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [fetchSupplySeed, name]);

  useEffect(() => {
    if (name === "chat" && fetchChatSeed) {
      fetchChatSeed
        .get("")
        .then((e) => {
          setChatSeed(e.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [fetchChatSeed, name]);

  useEffect(() => {
    if (name === "website" && fetchBookingSeed) {
      fetchBookingSeed.get("").then((e) => {
        setBookingSeed(e.data);
      });
    }
  }, [fetchBookingSeed, name]);

  return (
    <SeedContext.Provider
      value={{
        crsSeed,
        geetaSeed,
        profileSeed,
        supplySeed,
        chatSeed,
        discoverSeed,
        bookingSeed,
      }}
    >
      {children}
    </SeedContext.Provider>
  );
};

export default SeedProvider;
